export const imageUrl = (image) =>
  image ? `/.netlify/functions/collections-images?key=${encodeURIComponent(image.blobKey)}` : '';

export const findImageByRole = (collection, role) =>
  (collection && collection.images ? collection.images : []).find((img) => img.role === role);

export const galleryImages = (collection) =>
  (collection && collection.images ? collection.images : [])
    .filter((img) => img.role === 'gallery')
    .sort((a, b) => a.order - b.order);
